/* eslint-disable @stylistic/semi */

import Cookies from 'https://esm.archive.org/js-cookie'
import Tablesort from 'https://esm.ext.archive.org/tablesort'


import $ from '../util/jquery.js'
import '../util/center.js' // for $.center()
import '../util/popup.js'
import '../related/related.js'
import '../setUpCopyableTexts/setUpCopyableTexts.js'
import '../disabilityEligibility/disabilityEligibility.js';
import paramsToJSON from '../paramsToJSON/paramsToJSON.js'

import Manage from '../manage/manage.js'
import Banners from '../nav/banners.js'
import log from '../util/log.js'
import add_commas from '../util/add_commas.js'
import ios from '../util/ios.js'
import loginModal from '../login/loginModal.js'
import onclick from '../util/onclick.js'
import onchange from '../util/onchange.js'
import { debounce } from '../util/debounce.js'
import querySelector from  '../util/dom.js'

/* Donation Banner */
import '../donation-banner/donation-banner.js';

/* Reviews logic */
import '../ia-reviews/ia-reviews.js';

/* Topnav search bar with dropdown menu */
import '../ia-dropdown-search-bar/ia-dropdown-search-bar.js';

globalThis.Tablesort = Tablesort
import('https://esm.ext.archive.org/tablesort/src/sorts/tablesort.number.js').catch(() => {})

/* global  archive_analytics */


// class mnemonic: Archive JS
class AJS {
  static paramsToJSON() {
    return paramsToJSON()
  }

  static isTouchDevice() {
    return ('ontouchstart' in window ||
      (globalThis.DocumentTouch && document instanceof globalThis.DocumentTouch))
  }

  static theatre_controls_position($selectorIn, pegTop, widthIn, heightIn) {
    // We have lots of callers!  video, software, texts.
    // So sort out our args and where we gonna "peg"/glue things to...
    let $selector = $selectorIn
    const video = (heightIn  &&  !$selectorIn)
    if (!video) {
      if (!$selectorIn) $selector = $('#canvas') // software emulation
      if (!$selector.length) return // protect against emulated embeds and undef...
    }

    const height = (video ? heightIn : ($selector.height() || 0))
    const width  = (video ? widthIn  : ($selector.width() || 0))

    if (!video  &&  typeof pegTop !== 'undefined')
      $('#theatre-controls').offset({ top: pegTop })


    // Subtract out the width of the controls to get total amount of black pixels
    // to the right of the theatre object.
    // We want to position the controls in the middle of the dark pixels / right gutter!
    const right_gutter_width =
      Math.round(($('#theatre-ia-wrap').width() - $('#theatre-controls').width() - width) / 2)

    log('width', width)
    log('right_gutter_width', right_gutter_width)


    $('#theatre-controls').css({
      height,
      visibility: 'visible',
      right: Math.max(20, right_gutter_width / 2),
    })
  }


  /**
   * A general purpose theatre sizing function.
   * It keeps the metadata below the theatre partially visible.
   * @param {function} onChange - called when size changes
   * @global AJS.theatresize_maxheight if this is set by another
   *   part of the code, it will contrain to this max height.
   */
  static theatresize(onChange) {
    AJS.theatresize_maxheight ||= null
    const resizer = () => {
      const metadataHeight = 100 // metadata peekaboo min height!
      const maximumHeight = 1000 // don't get larger than this
      const minHeight = Math.min($(window).width(), 400)
      let targetHeight = $(window).height() - ($('#navwrap1').height() || 0) - metadataHeight

      if (AJS.theatresize_maxheight)
        targetHeight = Math.min(targetHeight, AJS.theatresize_maxheight)

      targetHeight = Math.max(targetHeight, minHeight)
      const height = Math.min(targetHeight, maximumHeight)
      $('#theatre-ia-wrap').addClass('resized').css('height', height)

      if (onChange)
        onChange($('#theatre-ia-wrap').height() || 0)
    }
    resizer() // page load event is now
    $(window).on('resize  orientationchange', () => {
      clearTimeout(AJS.theatresize_throttler)
      AJS.theatresize_throttler = setTimeout(resizer, 250)
    })
  }

  /**
   * Will reduce the vertical size of the carousel once all the images have
   * downloaded and only if they are all smaller than the current size.
   * This is a progressive enhancement
   * @param string selector
   * @param bool enableThreatreChange
   */
  static carouselsize(selector, enableThreatreChange) {
    const $carousel = $(selector)
    const imagePromises = $carousel.find('img.carousel-image').map((_i, img) => {
      const promise = $.Deferred()
      let result
      if (img.complete) {
        result = promise.resolve(img.naturalHeight).promise()
      } else {
        img.addEventListener('load', () => {
          promise.resolve(img.naturalHeight)
        })
        result = promise
      }
      return result
    }).get()
    $.when(...imagePromises).then((...args) => {
      const currHeight = $carousel.height()
      const maxImageHeight = Math.max(...args)
      if (currHeight > maxImageHeight) {
        $carousel.css('maxHeight', maxImageHeight)
        if (enableThreatreChange) {
          AJS.theatresize_maxheight = maxImageHeight
          $(window).trigger('resize')
        }
      }
    })
  }


  static popover_menu(selector, opts) {
    // setup options
    const options = {
      trigger: 'hover focus click', // make accessible
      container: selector,
      content: opts.content,
      html: true,
    }
    // do not overwrite values given by the 'data-' attribute
    if (opts.title)
      options.title = opts.title
    if (opts.placement)
      options.placement = opts.placement
    if (opts.trigger)
      options.trigger = opts.trigger

    // setup popover
    $(selector).popover(options)
  }


  // for microfilm books with many months of newspapers in PDF
  //   eg: /details/la_caleagle_reel1
  //
  // paginfo is a logical hashmap JSON object of:
  //   YYYYMMDD => [comma separated list of pages]
  // eg:
  //   20080129 =>  "1,2,3,11,17"
  static drawPDF(identifier, pageinfo) {
    const urlstart = '/download/'.concat(
      identifier, '/',
      identifier, '_pdf.zip/',
      identifier, '_pdf/', identifier, '_',
    )
    let multi_year = false
    let last_year  = false

    for (const key of Object.keys(pageinfo)) {
      const year = key.slice(0, 4)
      if (last_year === false) last_year = year
      if (last_year !== year) {
        multi_year = true
        break
      }
    }

    const sep = ''
    let str = sep
    let lastyearmonth = 666
    for (const key of Object.keys(pageinfo)) {
      if (key === 'yyyymmdd') continue

      // log(key); log(pageinfo[key]);
      const pages     = pageinfo[key].split(',')
      const year      = key.slice(0, 4)
      const month     = parseInt(key.slice(4, 6), 10)
      const day       = parseInt(key.slice(6, 8), 10)
      const yearmonth = year.concat('-', month)
      let skip_day = false

      let monthName = ''
      if (yearmonth !== lastyearmonth) {
        /**/ if (month ===  1)        monthName = 'January'
        else if (month ===  2)        monthName = 'February'
        else if (month ===  3)        monthName = 'March'
        else if (month ===  4)        monthName = 'April'
        else if (month ===  5)        monthName = 'May'
        else if (month ===  6)        monthName = 'June'
        else if (month ===  7)        monthName = 'July'
        else if (month ===  8)        monthName = 'August'
        else if (month ===  9)        monthName = 'September'
        else if (month === 10)        monthName = 'October'
        else if (month === 11)        monthName = 'November'
        else if (month === 12)        monthName = 'December'
        else if (month === undefined) monthName = 'Single Page PDFs'
        else /*             */        monthName = 'Unknown_'.concat(month)

        if (multi_year) monthName = year.concat(' ', monthName)

        // make header/a that shows/hides a hidden div after it with the month's data
        str += (str ? '</div><!--mo--><br/>' : '')
        str += `
<a href="#${monthName},${year}" class="year-month" data-toggle="#m${yearmonth}">
  <span class="iconochive-folder"></span> ${monthName}
</a>
<div class="mo" id="m${yearmonth}">`
      }

      // make header/a that shows/hides a hidden div after it with the page data
      if ((day === undefined) || (day === '')) skip_day = true
      if (skip_day) {
        str += '<div class="day">'
      } else {
        str += `
<div class="day">
<a href="#${yearmonth}-${day}" class="year-month-day" data-toggle="#m${yearmonth}d${day}">
  <span class="iconochive-folder" /> ${day}
</a>
<div class="pages" id="m${yearmonth}d${day}">`
      }

      // drop in the individual page links
      let offset = 1
      let page
      let pnum
      for (let j = 0; j < pages.length; j++) {
        page = pages[j]
        if (!page)

          continue
        if (offset > 0) offset = 1 - page
        pnum = parseInt(page, 10) + offset

        // left 0-pad to 4 digits as needed
        page = '0000'.concat(page)
        page = page.substr(page.length - 4, 4)

        const url = urlstart.concat(page, '.pdf')
        str += `<a href="${url}">[${pnum}]</a> `
      }

      if (skip_day)
        str += '</div>'
      else
        str += '</div><!--pages--></div><!--day-->'

      lastyearmonth = yearmonth
    }

    str += '</div><!--mo-->'

    // replace the "pdfs" empty div with our hefty HTML
    $('#pdfs .replaced').html(str)

    onclick('#pdfs .year-month', (e) => $($(e.currentTarget).data().toggle).toggle())
    onclick('#pdfs .year-month-day', (e) => $($(e.currentTarget).data().toggle).toggle())
  }


  static quick_down(id, target) {
    const idsel = `#${id}`

    if (!$('.format-group.in').length) {
      // no set of files for a single format showing... yet!
      const format = $(target).text()
      const $formatGroup = $(idsel).parents('.format-group')

      $('.download-button').html(format.concat(' FILES'))
      $formatGroup.addClass('in')
      // hide the other summary formats (one-liner) clickables
      $('.format-group:not(.in)').slideUp()
      $(idsel).slideDown()
    } else {
      // re-open all the summary formats (one-liner) clickables
      $('.format-group').slideDown(400)
      // close the open set of single files
      setTimeout(() => { // ftw, thx for nothing jquery
        $('.format-group.in').removeClass('in')
        $('.download-button').html('DOWNLOAD OPTIONS')
      }, 400)
      $(idsel).slideUp()
    }

    return false
  }


  // parse a CGI arg
  static arg(theArgName, try_full) {
    const sArgs = (try_full  &&  location.search === '' ?
      location.href.slice(1).split('&') :
      location.search.slice(1).split('&'))
    for (let i = 0; i < sArgs.length; i++) {
      if (sArgs[i].slice(0, sArgs[i].indexOf('=')) === theArgName) {
        const r = sArgs[i].slice(sArgs[i].indexOf('=') + 1)
        return (r.length > 0 ? unescape(r) : '')
      }
    }
    return ''
  }


  // when embed codes are being shown, adjust their heights so they show all the content/codes!
  static embed_codes_adjust() {
    log('showing embeds!')

    // these are found (only) on /details/ pages
    for (const embid of ['embedcodehere', 'embedcodehereWP']) {
      const $embid = $(`#${embid}`)
      $embid.removeAttr('rows').css('height', '')

      const embtxt = $embid.text()

      // this is *puke* city -- since textareas are a PITA, make a shadow div w/ the
      // text we want in it, trying to be same width, same font-size, etc.
      // and *then* insert into DOM invisibily so we can calculate its overall height
      // .. and then peg the textarea height to that height
      $('body').prepend($('<div/>').attr({
        id: `${embid}Shadow`,
        class: 'textarea-invert-readonly roundbox5',
      }).css({
        position: 'absolute',
        visibility: 'hidden',
        top: 60,
        left: 10,
        padding: '5px 15px 5px 15px',
        width: $embid.width(),
        'font-size': $embid.css('font-size'),
      })
        .text(embtxt))

      const bestHT = $(`#${embid}Shadow`).outerHeight() + 15
      log(embid, 'bestie height', bestHT, 'for current width', $embid.width())
      $(`#${embid}Shadow`).remove()

      $embid.height(bestHT)
    }
  }

  /**
   * Try to focus the last focusable descendent of the given element, if possible.
   * @param {HTMLElement} elmt - The parent element whose descendent should be focused
   * @param {HTMLElement?} fallback - An optional element to focus if no others are focusable
   */
  static focus_last_descendent(elmt, fallback) {
    // Iterate backwards through the descendents until we find something focusable
    const rootNode = $(elmt).get(0).getRootNode()
    const allDescendents = $(elmt).find('*')
    for (const descElmt of allDescendents.get().reverse()) {
      descElmt.focus()
      if (rootNode?.activeElement === descElmt) return // Found the last focusable one, we're done
    }

    fallback?.focus() // Nothing else was focusable, just focus the fallback element
  }

  /**
   * Dynamically adds modal to page (if isnt there already)
   * @param {String} selector - Id of the modal
   * @param {Object} conf - configuration options:
   *    @param {String || DOM Element} prepended_el - element that modal will be prepended to
   *    @param {String} headerClass - additional class(es) added to header div
   *    @param {String} title - innerHTML of modal h2 heading
   *    @param {String} body - innerHTML of modal body
   */
  static modal_add(selector, conf) {
    if ($(selector).length)
      $(selector).remove();

    const selectorID = selector.replace(/#/, '')
    const { prepended_el = document.body } = conf;

    $(prepended_el).prepend(`
<div id="${selectorID}" class="modal fade" role="dialog" aria-modal="true" aria-labelledby="modal-main-heading">
  <div class="modal-dialog modal-lg">
    <div class="focus-trap-start" tabindex="0"></div>
    <div class="modal-content">
      <div class="modal-header ${conf.headerClass !== undefined ? conf.headerClass : 'modal-header-std'}">
        <button type="button" class="close" data-dismiss="modal">
          <span class="iconochive-remove-circle"></span>
        </button>
        <h1 id="modal-main-heading" class="modal-title">
          ${typeof conf.title === 'undefined' ? 'Confirmed' : conf.title}
        </h1>
      </div>
      <div id="${selectorID}-body">
        ${typeof conf.body === 'undefined' ? '' : conf.body}
      </div>
    </div>
    <div class="focus-trap-end" tabindex="0"></div>
  </div>
</div>`)
    return $(selector);
  }

  /**
   * Parse API data and check if the item is successfully marked to favorite or not
   *
   * @param {String} bookmarkRes response data from /bookmarks.php?add_bookmark=1&...
   * @return {Boolean}
   */
  static isFavoriteSuccessful(bookmarkRes) {
    return (bookmarkRes.indexOf('<meta name="ia-favorite-success" content="1">') !== -1)
  }

  /**
   * Gives us ability to have JS intercept an href click and instead do a bootstrap modal.
   * We don't take user to the href target
   *
   * Used to open different modals Like Favorite list or item, share modal etc.
   * @param {HTMLElement} element - HTML element which have been clicked on
   * @param {Array} config - config is a hashmap with optional keys like:- auto_close,
   * auto_remove, * body, center, favorite, * ignore_lnk, titlen, headerClass, shown,
   * follow_link_on_dismiss, add_modal
   * @return {Boolean}
   */
  static modal_go(element, config) {
    const conf = config
    const $element = $(element)

    // load bootstrap JS on demand, if not already loaded (then re-call ourself)
    if (typeof $.fn.modal === 'undefined') {
      if (config.recalling)
        throw Error('still cant modal -- are there two jquery on the page?')
      // eslint-disable-next-line no-param-reassign
      config.recalling = 1
      void import('https://esm.archive.org/bootstrap@^3.0.0').then(() => AJS.modal_go(element, config))
      return false
    }

    if (conf.favorite) {
      // login is required to favorite item
      conf.login = true // must be logged in!
      conf.title = 'Log In'

      if (Cookies.get('logged-in-user') !== undefined) {
        // toggle favorite, unfavorite icon
        Manage.toggle_favorite_icon($element, true);

        // update favorite count on details page
        Manage.update_favorite_count(true);
      }
    }

    const selector = $element.attr('data-target')
    const href = conf.favorite ? $element.attr('data-href') : $element.attr('href');

    if (!conf.ignore_lnk  ||  conf.add_modal)
      AJS.modal_add(selector, conf)

    // Set up focus trap elements to wrap around when tabbing within the modal
    const closeButton = $(selector).find('.close')
    const focusTrapStart = $(selector).find('.focus-trap-start')
    const focusTrapEnd = $(selector).find('.focus-trap-end')

    focusTrapStart.on('focus', () => {
      const modalContents = $(selector).find('.modal-content')
      AJS.focus_last_descendent(modalContents, closeButton)
    })

    focusTrapEnd.on('focus', () => {
      // Send focus to the Close button at the top of the dialog
      closeButton.focus()
    })

    if (conf.shown) {
      $(selector).on('shown.bs.modal', () => {
        conf.shown()
      })
    }

    if (conf.follow_link_on_dismiss) {
      $(selector).on('hidden.bs.modal', () => {
        log('modal hidden, going to ', href, '..')
        $('body').removeClass('blurry')
        location.href = href
      })
    }

    if (conf.login && Cookies.get('logged-in-user') === undefined) {
      if (location.protocol !== 'https:') {
        // make absolutely sure we never login with http!
        location.href = 'https://archive.org/login'
        return false
      }

      const url = '/account/login.embed.php'
      $.get(url, (htmIn) => {
        // this allows us to effectively rip off the header/nav and footer
        // if we are accessing a full page (eg: account login page)
        const htm = ($(htmIn).find('.container-ia > div').length ?
          $(htmIn).find('.container-ia > div').get(0) :
          htmIn
        )

        // Add class to identify as login variant
        $(selector).addClass('login-modal')

        $(selector.concat('-body')).html(htm)
        $(selector).modal('show')

        $(selector).on('shown.bs.modal', () => {
          // Focus the email input field when opened
          $(selector).find('.input-email').focus()
        })

        $(selector).on('hide.bs.modal', () => {
          // Upon closing, return focus to the element that first triggered the modal
          element.focus()
        })

        const $form = $(selector.concat('-body form:has(input[type=submit])'))
        if (!$form.length)
          return

        const $icon = $('.password_icon')[0]

        if (navigator.cookieEnabled === true) {
          $('.cookie-warning').addClass('hidden')
          $('.login-form :input').prop('disabled', false)

          $icon.src = '/images/eye-crossed.svg'
          $icon.alt = 'Show text'

          $('.js-togglePasswordVisibility').on('click', () => {
            const $input_password = $('.input-password')[0]
            if ($input_password.type === 'password') {
              $input_password.type = 'text'
              $icon.src = '/images/eye.svg'
              $icon.alt = 'Hide text'
            } else {
              $input_password.type = 'password'
              $icon.src = '/images/eye-crossed.svg'
              $icon.alt = 'Show text'
            }
          })

          $('.input-email, .input-password').on('focus', () => {
            $('.password-error').html('')
            $('.reset-password').show()
          })
        } else {
          // If no cookies, show warning, disable login form
          $('.cookie-warning').removeClass('hidden')
          $('.login-form :input').prop('disabled', true)
        }

        loginModal({
          $form,
          url,
          selector,
          element,
          conf,
        })
      })

      return false
    }

    if (conf.auto_remove) {
      conf.auto_close = true
      $(selector).on('hidden.bs.modal', () => {
        $(selector).remove()
        $('body').removeClass('blurry')
      })
    }

    if (!conf.ignore_lnk) {
      $.get(href, (res) => {
        if (conf.favorite) {
          if (typeof archive_analytics !== 'undefined') {
            archive_analytics.send_ping({
              kind: 'event',
              ec: 'page_action',
              ea: 'favorite',
              el: location.pathname,
              cache_bust: Math.random(),
            })
          }

          if (AJS.isFavoriteSuccessful(res)) {
            setTimeout(() => {
              if (conf.postLogin)
                location.reload(true)
            }, AJS.modalInterval)
          } else {
            // toggle favorite, unfavorite icon
            Manage.toggle_favorite_icon($element, false);

            // update favorite count on details page
            Manage.update_favorite_count(false);

            const $favModal = $(selector)
            const failMessage = `
              <center>
                <p class="favorite-failure-message">
                  There was an error adding the favorite. If the problem persists, please contact support.
                </p>
              </center>
            `
            $favModal.find('.modal-title').html('Failed')
            $favModal.find(`${selector}-body`).html(failMessage)
            $(selector).modal('show')
          }
        } else {
          $(selector).modal('show')
          if (conf.auto_close)
            setTimeout(() => $(selector).modal('hide'), AJS.modalInterval)
        }

        // Focus the modal close button
        $(selector).find('.close').focus()
      })
      $(selector).on('hidden.bs.modal', () => {
        $(selector).remove()
      })
    } else {
      $(selector).modal('show')
    }

    if (conf.center)
      $(selector.concat(' .modal-dialog')).center() // vertically center

    if (conf.auto_close && conf.ignore_lnk)
      setTimeout(() => $(selector).modal('hide'), AJS.modalInterval)

    return false
  }


  static suffixFmt(val, axis) {
    if (axis.min >= 0.0  &&  axis.max <= 5)
      // give a little bit more granularity of 1 decimal point...
      return Math.round(val * 10, 1) / 10

    if (val >= 1000000) return (val / 1000000).toFixed(0).concat(' M')
    if (val >=    1000) return (val /    1000).toFixed(0).concat(' K')
    return val.toFixed(0)
  }


  static suffixFmtPercent(val, axis) {
    return AJS.suffixFmt(val, axis).concat('%')
  }


  /**
   * Return singular or plural string given integer
   *
   * @param {integer} nInt integer
   * @param {string} strOne singular string
   * @param {string} strMany plural string
   */
  static pluralize(nInt, strOne, strMany) {
    if (nInt === 1) {
      // Singular
      return strOne
    }
    // Plural
    return strMany
  }

  /**
   * Return table tooltip of stack chart values
   *
   * @param {array} time split string of date
   * @param {array} values int stack chart values
   * @param {array} labels string stack chart labels
   */
  static viewMessage(time, values, labels) {
    const rows = values.length
    let msg = '<table><tr>'
    msg += `<th class="tt-date" rowspan="${rows}">${time[2]} ${time[3]}</th>`
    msg += `<td class="tt-number">${add_commas(values[0])}</td>`
    msg += `<td>${AJS.pluralize(values[0], 'View', 'Views')} ${labels[0]}</td></tr>`
    // For every stack after the 0th above
    for (let i = 1; i < rows; i++) {
      msg += `<tr><td class="tt-number">${add_commas(values[i])}</td>`
      msg += `<td>${AJS.pluralize(values[i], 'View', 'Views')} ${labels[i]}</td></tr>`
    }
    msg += '<table>'
    return msg
  }


  static plot_graphs() {
    $('.js-ajs-plotter').each((_idx, e) => {
      const kv = JSON.parse($(e).val())
      AJS.plotter(() => {
        log('js-ajs-plotter', kv)
        const cfg = JSON.parse(kv.cfg)
        if (kv.dayBarsNoPoints)
          cfg.dayBarsNoPoints = true
        if (kv.dark)
          cfg.dark = true

        // string => function nonideal, but moving on...
        if (cfg.yaxis?.tickFormatter === 'AJS.suffixFmt')
          cfg.yaxis.tickFormatter = AJS.suffixFmt

        if (kv.fmt === 'AJS.broadcastsTooltip')
          kv.fmt = AJS.broadcastsTooltip
        else if (kv.fmt === 'AJS.airedTooltip')
          kv.fmt = AJS.airedTooltip
        else if (kv.fmt?.length === 3 && kv.fmt[0] === 'AJS.graphsTooltip')
          kv.fmt = AJS.graphsTooltip(kv.fmt[1], kv.fmt[2])
        else if (kv.fmt?.length === 3 && kv.fmt[0] === 'AJS.statsTooltip')
          kv.fmt = AJS.statsTooltip(kv.fmt[1], kv.fmt[2])

        AJS.plot(kv.id, cfg, kv.fmt, JSON.parse(kv.pts), kv.many)
      })
    })
  }

  static broadcastsTooltip(x, y) {
    const t = new Date(x).toUTCString().split(' ')
    return `<nobr>${add_commas(y)} broadcasts on ${t[2]} ${t[3]}</nobr>`
  }

  static airedTooltip(x, y) {
    const t = new Date(x).toDateString().split(' ')
    return `<nobr>Aired ${add_commas(y)} times on ${t[1]} ${t[2]}</nobr>`
  }

  static graphsTooltip(gtitle, xindex) {
    return (x, y) => {
      const t = new Date(x).toDateString().split(' ')
      return `<nobr>${add_commas(y)} ${gtitle} in ${t[1]} ${xindex === 'day' ? t[2] : ''} ${t[3]}</nobr>`
    }
  }

  /**
   * Return function to be evaluated as graph item tooltip
   *
   * @param {string} method type of formatting string
   * @see www/common/Graph.inc Graph::easyBarsXTime()
   */
  static statsTooltip(method, dateOffset = 0) {
    let message
    switch (method) {
      case 'main': {
        message = ({ y, t }) => `${add_commas(y)} total items in <strong>${t[2]} ${t[3]}</strong>`
        break
      }
      case 'item': {
        message = ({ t, item }) => `<strong>${t[2]} ${t[3]}</strong>: ${add_commas(item.datapoint[1])} ${AJS.pluralize(item.datapoint[1], 'Item', 'Items')}`
        break
      }
      case 'download': {
        message = ({ t, item }) => `<strong>${t[2]} ${t[3]}</strong>: ${add_commas(item.datapoint[1])} ${AJS.pluralize(item.datapoint[1], 'Download', 'Downloads')}`
        break
      }
      case 'view': {
        message = ({ t, values, labels }) => AJS.viewMessage(t, values, labels)
        break
      }
      default: {
        break
      }
    }
    const fn = (x, y, item, values, labels) => {
      const t = new Date(x - dateOffset).toUTCString().split(' ')
      const params = {
        x, y, item, t, values, labels,
      }
      return `<span style="white-space: nowrap;">${message(params)}</span>`
    }
    return fn
  }

  // this allows easy setup for resize/orientation triggers for all graphs
  // on a page that use this!
  static plotter(callback) {
    if (typeof AJS.plotters === 'undefined')
      AJS.plotters = []

    if (callback) {
      // stash a copy of the callback for resize/orientationchange triggers
      AJS.plotters.push(callback)

      // now do the actual plotting (eg: page load)
      callback()
    } else {
      // step through each graph and rerun them
      log('plotter() resize/orient change', AJS.plotters.length, 'graphs to resize')
      for (let i = 0; i < AJS.plotters.length; i++)
        AJS.plotters[i]()
    }
  }


  // Graphing for archive.org/services/views.php and TV
  static plot(id, cfgIn, fmt_fn, pts, many) {
    const cfg = cfgIn
    cfg.xaxis ||= { mode: 'time', color: (cfg.dark ? '#ccc' : '#545454') }
    cfg.yaxis ||= { color: (cfg.dark ? '#ccc' : '#545454') }

    let barWidth
    if (many && cfg.barWidth)
      barWidth = cfg.barWidth * 1 // *1 to pass lint; keeps like below; avoid obj destructuring
    else if (cfg.barWidth)
      barWidth = cfg.barWidth * 86400 * 1000
    else
      barWidth = (cfg.dayBarsNoPoints ? 1 : 7) * 86400 * 1000 // 1day|1week

    cfg.color ||= '#385C74'

    if (cfg.stack) {
      cfg.series = {
        stack: true,
        bars: {
          show: true,
          barWidth,
          fill: true,
        },
        legend: {
          show: true,
        },
      }
    } else {
      cfg.series = {
        bars: {
          show: true,
          barWidth,
          fill: 0.6,
          color: cfg.color,
        },
        color: cfg.color,
        points: { show: !cfg.dayBarsNoPoints },
      }
    }

    if (typeof cfg.grid === 'undefined') {
      cfg.grid = {
        borderColor: (cfg.dark ? '#333' : '#aaa'),
        hoverable: true,
      }
    }
    // log(cfg.series.bars)


    if (cfg.dark)
      cfg.grid.backgroundColor = '#002b36'

    cfg.tip ||= {}
    cfg.tip.id ||= id

    if (typeof window.GraphPriorIndex === 'undefined')
      window.GraphPriorIndex = {}

    // fully elaborated graph data
    let graph_data = []
    if (cfg.series.stack) {
      // [{},{}, ...]
      // each with data:[], label:""
      graph_data = pts
    } else {
      graph_data = (many ? pts : (typeof pts.data === 'undefined' ? [{ data: pts }] : [pts]))

      if (cfg.dayBarsNoPoints  &&  !cfg.noLabel)
        graph_data[0].label = id
    }

    const selid = `#${id}`

    void import('https://esm.archive.org/flot@%5E0.8.0').then(() => {
      // import plugins in parallel
      void Promise.all([
        import('https://esm.archive.org/flot@%5E0.8.0/jquery.flot.time.js'),
        import('https://esm.archive.org/flot@%5E0.8.0/jquery.flot.stack.js'),
      ]).then(() => {
        const plotFunction = $.plot($(selid), graph_data, cfg)

        if (!fmt_fn)
          return

        $(selid).bind('plothover', (_event, pos, item) => {
          if (!item) {
            window.GraphPriorDatapoint = [0, 0, 0]
            $('#gtip').remove()
            return
          }

          if (window.GraphPriorDatapoint !== item.datapoint) {
            window.GraphPriorDatapoint = item.datapoint
            $('#gtip').remove()

            const values = []
            const labels = []
            // If stack graph, prepare data and labels for tooltip
            if (cfg.stack) {
              const data = plotFunction.getData()
              // For each series of data (stack in stacked graph)
              for (let i = 0; i < data.length; i++) {
                const series = data[i]
                labels[i] = series.label
                for (let j = 0; j < series.data.length; j++) {
                  // If same x value as mouseover value
                  if (series.data[j][0] === item.datapoint[0]) {
                    // store y value

                    values[i] = series.data[j][1]
                    break
                  }
                }
              }
            }

            const str = fmt_fn(item.datapoint[0], item.datapoint[1], item, values, labels)
            const $graf = $(selid)
            const off = $graf.offset()

            // figure out which way from the "dot"/bar in the graph the
            // tooltip should go -- left or right!
            let { pegTo } = cfg.tip
            pegTo ||= ((pos.pageX - off.left) > ($graf.width() / 2) ? 'right' : 'left')

            const pegToVal = (pegTo === 'right' ?
              ($graf.width() - (pos.pageX - off.left - 20)) :
              (pos.pageX - off.left) + 20)
            log(pegTo, pegToVal)

            $(`#${cfg.tip.id}`).append(`<div id="gtip" class="roundbox5 grafs-tooltip" style="top:${pos.pageY - off.top}px; ${pegTo}:${pegToVal}px">${str}</div>`).fadeIn(200)
          }
        })
      })
    })
  }


  /**
   * Use the following function to make an image, div, etc focusable, and 'click'-able.
   * Function adds a tabindex for 'focus' and listens for a keydown/keypress of enter or space,
   * then triggers a click.
   *
   * var element: String used for jquery capture of non-acessible & mouse-only element.
   *    ex: "#AmazonPayButton img"
   * Triggers 'click' on element.
   */
  static makeMouseElementAccessible(element) {
    $(element).attr('tabindex', '0').on('keypress keydown', function makeMouseElementAccessibleGo(e) {
      if (e.type !== 'click') {
        const code = (e.keyCode || e.which)
        const k_space = 32 // space bar pressed
        const k_enter = 13 // enter key pressed
        if ([k_space, k_enter].indexOf(code) !== -1)
          $(this).click()
      }
    })
  }


  // use something like ',' for the optional 3rd arg if you want to allow
  // for appending 2+ values into a field, etc...
  static async autocomplete(selector, options, multiValSplitChar) {
    await import('https://esm.archive.org/jqueryui@1.11.1/jquery-ui.min.js').then(() => {
      $(selector).autocomplete({
        appendTo: '#autocompletee', // NOTE: ending `ee` is correct ;-)
        minLength: 0,
        source: (request, response) => {
          // delegate back to autocomplete, but extract the last term
          response($.ui.autocomplete.filter(options, request.term.split(/,\s*/).pop()))
        },
        focus: () => false, // prevent value inserted on focus
        select: function autocomplete_select(_event, ui) {
          if (multiValSplitChar) {
            const terms = this.value.split(/,\s*/)
            // remove the current input
            terms.pop()
            // add the selected item
            terms.push(ui.item.value)
            // add placeholder to get the comma-and-space at the end
            terms.push('')
            this.value = terms.join(', ')
          } else {
            this.value = ui.item.value
          }
          return false
        },
      })
    })
  }


  static thumbzilla(id = '') {
    /* global  TV2  */
    // cover entire screen with new div...
    const TV = $('body').hasClass('tv')
    if (TV && window?.TV2) // NOTE: TV2 isnt a global JS var anymore
      TV2.unplay('thumbzilla')

    // eslint-disable-next-line no-param-reassign
    id ||= location.pathname.match(/\/details\/([^/&?]+)/)?.[1]

    let htm = ''

    // we might be calling this after AJAX success below, finding the item thumbnails
    const render = () => {
      $('#opscreen1M').remove()
      $('body').prepend($('<div />').attr({ id: 'opscreen1M' }))

      const $imgs = $('<div/>').attr({ id: 'thumbzilla' }).html(`<div>${htm}</div>`)
      $imgs.appendTo('#opscreen1M')
      $('#opscreen1M').css('visibility', 'hidden').show()
      const winH = $(window).height() + (ios ? 60 : 0) // plus iOS bleah
      for (let w = 720; w >= 10; w -= 10) {
        const h = Math.round(w * (110 / 160.0))
        log('TRYING', w, 'x', h)
        $('#thumbzilla img').css({ width: w, height: h })
        if ($('#thumbzilla img:last').offset().top + h <= winH)
          break
      }

      $('#thumbzilla div').center()
      $('#opscreen1M').hide().css('visibility', 'visible').fadeIn('slow')
        .one('click.opscreen1M.nixer', () => $('#opscreen1M').fadeOut('slow'))
      if (window?.TV2) {
        onclick('.js-tvthumb', (e) => {
          $('#opscreen1M').fadeOut('slow')
          TV2.seekURL($(e.currentTarget).href.replace(/^\/details\/[^/+]/, ''))
        })
      }
    }


    // get list of thumbs
    if (TV && $('.js-tv3-init').length) {
      const TV3 = JSON.parse($('.js-tv3-init').val() ?? '{}')
      $(TV3['TV3.thumbzillas']).each((_key, val) => {
        const start = parseInt(val, 10)
        const startend = `/details/${id}/start/${start}/end/${start + TV3['TV3.CLIP_SEC_MAX2']}`
        htm += `<a class="js-tvthumb" href="${startend}">`
        htm += `<img src="/download/${id}/${id}.thumbs/${id}_${val}.jpg"/></a>`
      })
      render()
    } else {
      $.getJSON(`/metadata/${id}/files`, (resp) => {
        for (const file of resp.result) {
          const start = 'original' in file  &&  file.name.match(/\.thumbs\/.*_([0-9]+)\.jpg$/)
          if (start) {
            htm += `
              <a href="/details/${id}/${file.original}?start=${Number(start[1])}"><img src="/download/${id}/${file.name}"></a>
            `
          }
        }
        if (htm)
          render()
      })
    }

    return false
  }


  /**
   * Expandable/collapsible accordion component, implemented with <details>
   * elements
   *
   * The JavaScript guarantees only one <details> is open at a time and
   * scrolls the open <details>'s content into view.
   *
   * @see accordion.less
   */
  static setUpAccordions() {
    /**
     * Closes all <details> elements in detailsEls, except selectedDetails
     *
     * @param {HTMLDetailsElement[]} detailsEls
     * @param {HTMLDetailsElement}   selectedDetails
     */
    function closeAllExcept(detailsEls, selectedDetails) {
      Array.from(detailsEls)
        .forEach((details) => {
          if (details !== selectedDetails) {
            // eslint-disable-next-line no-param-reassign
            details.open = false
          }
        })
    }

    /**
     * Sets up a single accordion component
     *
     * @param {HTMLElement} accordion
     */
    function setUpAccordion(accordion) {
      /**
       * Responds to the "toggle" event on a <details>
       *
       * @param {Event} event
       */
      function handleToggle(event) {
        if (!event.target.open) return

        closeAllExcept(
          accordion.querySelectorAll('details'),
          event.target,
        )

        // See https://www.abeautifulsite.net/smoothly-scroll-to-an-element-without-a-jquery-plugin-2
        $('html, body').animate({
          scrollTop: $(event.target).offset().top,
        }, 400)
      }

      Array.from(accordion.querySelectorAll('details'))
        .forEach((details) => {
          details.addEventListener('toggle', handleToggle)
        })

      accordion.setAttribute('data-accordion-ready', '')
    }

    Array.from(document.querySelectorAll('[data-accordion]'))
      .forEach(setUpAccordion)
  }


  // Returns true if element's text is clamped
  // I.e. text currently has rows hidden by -webkit-line-clamp
  static isTextClamped(element) {
    return element.clientHeight < element.scrollHeight;
  }

  // Add checkbox click event listener
  static bindClampCheckbox(element) {
    // Assumes <input type="checkbox"> is next sibling of js-clamp element
    const inputElement = element.nextElementSibling
    if (inputElement && inputElement.type === 'checkbox') {
      let ElementTop;
      let scrollTop;
      $(inputElement).on('click', () => {
        if ($(inputElement).is(':checked')) {
          // "More" clicked, set Y restore value
          const WindowTop = window.visualViewport.pageTop
          ElementTop = element.getBoundingClientRect().top + WindowTop
          // If top of element is not in view, set to scroll slightly above top of element
          scrollTop = (ElementTop < WindowTop) ? ElementTop - 10 : WindowTop
        } else if (ElementTop < window.visualViewport.pageTop) {
          // "Less" clicked, scroll window back to where "More" clicked
          window.scrollTo({ top: scrollTop, behavior: 'instant' })
        }
      })
    }
  }

  // Remove checkbox click event listener
  static unbindClampCheckbox(element) {
    // Assumes <input type="checkbox"> is next sibling of js-clamp element
    const inputElement = element.nextElementSibling;
    if (inputElement && inputElement.type === 'checkbox' && inputElement.checked) {
      $(inputElement).off('click')
    }
  }
} // end class AJS

$(() => {
  // avoid this entire block potentially running twice, via two AJS instances, due to
  // archive.js <=> manage.js importing each other
  if (globalThis.AJS_loaded) return
  globalThis.AJS_loaded = true

  // Use this global hack, by adding class 'accessible-link' to any mouse-only element div/img
  AJS.makeMouseElementAccessible('.accessible-link')

  if (typeof archive_analytics !== 'undefined')
    archive_analytics.set_up_event_tracking()

  // UI component initialization
  AJS.setUpAccordions()

  if (typeof archive_analytics !== 'undefined')
    archive_analytics.create_tracking_image('external_executes')

  AJS.modalInterval = 2000

  Banners.init()


  AJS.plot_graphs()

  $('.js-pages').each((_idx, e) => {
    const kv = JSON.parse($(e).val())
    AJS.drawPDF(kv.identifier, JSON.parse(kv.pages))
  })

  $('.js-carousel2').each(() => {
    AJS.theatresize()
    AJS.carouselsize('#ia-carousel', true)
  })


  document.querySelectorAll('table.Tablesort').forEach((t) => new Tablesort(t))

  onclick('.js-ebook-maker', async (el) => {
    const e = el.currentTarget
    e.parentElement.textContent = 'Generating...'

    const { maker } = $(e).data()
    log({ maker })


    const body = new URLSearchParams()
    for (const [k, v] of Object.entries(maker))
      body.append(k, encodeURIComponent(v))


    const res = await fetch('/services/make-ebook.php', { method: 'POST', body })
    log({ res })
  })

  // Using tooltips will require bootstrap JS to be loaded
  const tooltips = !AJS.isTouchDevice()  &&  typeof $.fn.tooltip === 'undefined'
    ? $('.container-ia [data-toggle="tooltip"], #cols [data-toggle="tooltip"], #tvbanner [data-toggle="tooltip"], #cher-modal [data-toggle="tooltip"]')
    : []

  if (tooltips.length) {
    void import('https://esm.archive.org/bootstrap@^3.0.0').then(() => {
      if (tooltips.length)
        tooltips.tooltip({})
    })
  }


  onclick('.js-createclick', () => { location.href = '/create/' })

  onclick('.js-inliner', (e) => {
    if (window.inlined)
      return
    window.inlined = true

    const href = `${e.currentTarget.href}&nochrome=1`
    const appendPageContentsHere = $(e.currentTarget).parent().parent().parent()
    appendPageContentsHere.append(
      '<div id="loadin" style="padding:50px"><hr/><h4><img src="/images/loading.gif"/> loading...</h4><hr/></div>',
    )

    $.get(href, (htm) => {
      $('#loadin').remove()
      appendPageContentsHere.append(`<hr/>${htm}`)
    })
  })

  onclick('.js-auto-submit-perpetual', () => {
    document.getElementById('timeout_row').style.display = 'table-row'
    document.getElementById('loopsleep_row').style.display = 'table-row'
    document.getElementById('discard_itemlists_row').style.display = 'table-row'

    document.getElementById('timeout_row').classList.toggle('hidden')
    document.getElementById('loopsleep_row').classList.toggle('hidden')
    document.getElementById('discard_itemlists_row').classList.toggle('hidden')
  }, 'default')

  onchange('.js-auto-submit-cmd', (e) => {
    if (e.currentTarget.value === 'delete.php') {
      alert(`
        WARNING: The "lost_item" arg is automatically
        added to delete.php tasks submitted through this form.
        That means the command can be used only to
        tidy our records for items that have already
        gotten lost, not to delete existing items.
        If run on an item that actually exists still,
        the task will redrow.`)
    }
  })

  onclick('.js-ajs-deadlists', (e) => {
    const { href } = e.currentTarget
    window.open(
      href,
      'popup',
      'width=800,height=600,scrollbars=yes,resizable=yes,toolbar=no,directories=no,location=no,menubar=no,status=no',
    )
  })

  onclick('.show-more-button', (e) => {
    $('.metadata-hidden').slideToggle('fast');
    $(e.currentTarget).find('.show-more-button__text').toggle();
  });

  // expand downloadable files
  onclick('.js-archive-expand_files', (e) => {
    const element = $(e.currentTarget)
    const id = element.data('id')
    if (id) {
      AJS.quick_down(id, element)
    }
  })

  // collapse downloadable files
  onclick('.js-archive-collapse_files', (e) => {
    const element = $(e.currentTarget)
    const id = element.data('id')
    if (id) {
      AJS.quick_down(id)
    }
  })

  onclick('.js-catalog-delete', (e) => {
    if (!confirm('Are you sure you want to *delete* these tasks?')) {
      e.preventDefault(); // Only cancel if not confirmed
    }
    // otherwise, allow native submit to proceed
  }, 'default');


  // remove bookmarks/favorites from /bookmarks.php page
  onclick('.js-bookmark-removeBookmark', (e) => {
    if (confirm('Are you sure you want to delete this favorite?')) {
      const url = $(e.currentTarget).attr('href');
      if (url) window.location = url
    }
  });

  onclick('.js-bookmarks-addCommentForm', (e) => {
    const identifier = $(e.currentTarget).attr('identifier')
    const action = $(e.currentTarget).attr('action')

    const cancelCommentField = () => {
      const formElement = document.getElementById(`${identifier}_form`)
      formElement.parentNode.removeChild(formElement)

      const linkObject = document.getElementById(`${identifier}_commentLink`)
      linkObject.style.display = ''

      const existingComment = document.getElementById(`${identifier}_existingComment`)
      if (existingComment)
        existingComment.style.display = ''
    }

    const formElement = document.createElement('form')
    formElement.action = action
    formElement.method = 'post'
    formElement.id = `${identifier}_form`
    formElement.style.margin = '0'
    formElement.style.fontSize = '12px'
    formElement.appendChild(document.createTextNode('Comment: '))

    const textBox = document.createElement('input')
    textBox.name = 'add_comment'
    textBox.type = 'text'
    if (document.getElementById(`${identifier}_existingCommentText`))
      textBox.value = document.getElementById(`${identifier}_existingCommentText`).innerHTML
    formElement.appendChild(textBox)

    const idField = document.createElement('input')
    idField.name = 'identifier'
    idField.type = 'hidden'
    idField.value = identifier
    formElement.appendChild(idField)

    const goButton = document.createElement('input')
    goButton.name = 'submit'
    goButton.type = 'submit'
    goButton.value = 'Save'
    formElement.appendChild(goButton)

    const cancelButton = document.createElement('input')
    cancelButton.type = 'button'
    cancelButton.id = `${identifier}_cancelButton`
    cancelButton.rel = identifier
    cancelButton.onclick = cancelCommentField
    cancelButton.value = 'Cancel'
    formElement.appendChild(cancelButton)

    document.getElementById(`${identifier}_formSpan`).appendChild(formElement)

    const linkObject = document.getElementById(`${identifier}_commentLink`)
    linkObject.style.display = 'none'

    const existingComment = document.getElementById(`${identifier}_existingComment`)
    if (existingComment)
      existingComment.style.display = 'none'
  })

  // For useradmin.php
  // Copy emails to clipboard
  const clipboardButton = document.querySelector('#js-useradmin-clipboard')
  if (clipboardButton) {
    clipboardButton.addEventListener('click', () => {
      const emails = Array.from(document.querySelectorAll('.js-useradmin-username'))
        .map((element) => element.textContent)
        .join(' ')
      void navigator.clipboard.writeText(emails)
    })
  }

  const copyLinkButton = document.querySelector('#copy-link');
  if (copyLinkButton) {
    copyLinkButton.addEventListener('click', (e) => {
      e.preventDefault();

      const { copylink } = copyLinkButton.dataset;
      void  navigator.clipboard.writeText(copylink);

      const linkEle = copyLinkButton.querySelector('.sharee');
      if (linkEle) $(linkEle).attr('data-original-title', 'Copied!').tooltip('show');
    });
  }

  const searchForm = document.querySelector('.js-useradmin-search')
  if (searchForm) {
    // Disable empty inputs for clean GET querystring
    searchForm.addEventListener('submit', (e) => {
      e.preventDefault()
      Array.from(searchForm.querySelectorAll('input'))
        .filter((element) => !element.value)
        .forEach((element) => {
          const inputCopy = element
          inputCopy.disabled = true
        })
      searchForm.submit()
    })

    // Clear disabled inputs on page load
    Array.from(searchForm.querySelectorAll('input'))
      .forEach((element) => {
        const inputCopy = element;
        inputCopy.disabled = false;
      })
  }
  // End for useradmin.php


  // For setadmin.php
  const selector = '#autocompletee input';
  const $input = $(selector);
  const $loader = $('#loader');

  $input.on('input', debounce(() => {
    const value = $input.val();
    if (value.length >= 3) {
      $loader.show();

      $.getJSON(`?search=${encodeURIComponent(value)}`)
        .done(async (data) => {
          $loader.hide();

          // Ensure autocomplete is fully initialized before triggering search
          await AJS.autocomplete(selector, data);

          // Now safely trigger search
          $(selector).autocomplete('search', value);
        })
        .fail(() => {
          $loader.hide();
        });
    }
  }, 500));
  // End for setadmin.php

  // For details.inc
  // Can be used for any element with text that needs to be clamped/unclamped
  // Presence/absence of clampedClass can be used to show/hide a "more/less" button/checkbox
  // @see www/sf/includes/less/partials/item-details-metadata.less
  // Check if any texts are clamped and set clamped class
  const clampableElements = $('.js-clamp')
  const clampedClass = 'clamped'

  if (clampableElements.length) {
    clampableElements.each((_index, element) => {
      // isTextClamped() only works on element with text, not starting at any parent
      if (AJS.isTextClamped(element)) {
        element.classList.add(clampedClass)
        AJS.bindClampCheckbox(element)
      }
    })

    // Listen for window resize and re-check if any texts are now clamped
    globalThis.addEventListener('resize', debounce(() => {
      clampableElements.each((_index, element) => {
        if (AJS.isTextClamped(element)) {
          // No-op if already set
          element.classList.add(clampedClass)
          AJS.bindClampCheckbox(element)
        } else {
          AJS.unbindClampCheckbox(element)
          element.classList.remove(clampedClass)
        }
      })
    }), 50)
  }

  // details page share-modal begin-play-at
  const beginPlayElement = document.getElementById('begin-play-section');
  if (beginPlayElement) {
    const inputField = beginPlayElement.querySelector('#begin-play-at');
    const checkbox = beginPlayElement.querySelector('#check-begin-play-at');

    if (inputField && checkbox) {
      const timecodeToSeconds = (timecode) => {
        if (!timecode.includes(':')) {
          return Number(timecode);
        }
        const parts = timecode.split(':');
        if (parts.length === 2) {
          const [minutes, seconds] = parts.map(Number);
          return minutes * 60 + seconds;
        }

        const [hours, minutes, seconds] = parts.map(Number);
        return hours * 3600 + minutes * 60 + seconds;
      }

      const secondsToTimecode = (seconds) => {
        if (seconds >= 3600) {
          const hours = Math.floor(seconds / 3600);
          const minutes = Math.floor((seconds % 3600) / 60);
          const secondsRemaining = seconds % 60;
          return `${hours}:${String(minutes).padStart(2, '0')}:${String(secondsRemaining).padStart(2, '0')}`;
        }

        const minutes = Math.floor(seconds / 60);
        const secondsRemaining = seconds % 60;
        return `${minutes}:${String(secondsRemaining).padStart(2, '0')}`;
      }

      const isValidTimeFormat = (value) => {
        if (!value.includes(':')) {
          return !isNaN(Number(value)) && Number(value) >= 0;
        }

        const parts = value.split(':').map(Number);
        if (parts.length === 2) {
          return parts[0] >= 0 && parts[1] >= 0 && parts[1] < 60;
        }
        if (parts.length === 3) {
          return parts[0] >= 0 && parts[1] >= 0 && parts[1] < 60 && parts[2] >= 0 && parts[2] < 60;
        }
        return false;
      }

      const formatTimecode = (value) => {
        const seconds = timecodeToSeconds(value);
        return secondsToTimecode(seconds);
      }

      const updateInputField = () => {
        const videoPlayer = querySelector('video');
        if (!videoPlayer) return;
        const currentTime = secondsToTimecode(Math.floor(videoPlayer.currentTime));
        inputField.value = currentTime;
      }

      const toggleStartParam = (targetUrl, valueInSeconds) => {
        if (checkbox.checked && valueInSeconds) {
          targetUrl.searchParams.set('start', valueInSeconds)
        } else {
          targetUrl.searchParams.delete('start')
        }
      }

      // Update social share links
      const updateShareLinks = () => {
        const { value } = inputField;
        if (checkbox.checked && !isValidTimeFormat(value)) {
          return;
        }

        document.getElementById('sharer').querySelectorAll('a').forEach((link) => {
          const targetUrl = new URL(window.location.href);
          const sharerLink = new URL(link.href);
          const valueInSeconds = timecodeToSeconds(value);

          // update URL in email body
          if (sharerLink.href.startsWith('mailto:')) {
            const param = new URLSearchParams(sharerLink.href.split('?')[1] || '');
            const subject = param.get('subject') || '';
            toggleStartParam(targetUrl, valueInSeconds);
            link.setAttribute(
              'href',
              `mailto:?body=${encodeURIComponent(targetUrl.href)}&subject=${encodeURIComponent(subject)}`,
            );
            return;
          }

          // update URL on copy button
          if (Object.hasOwn(link.dataset, 'copylink')) {
            toggleStartParam(targetUrl, valueInSeconds);
            Object.defineProperty(link.dataset, 'copylink', {
              value: targetUrl.href,
            });
            return;
          }

          for (const [param] of sharerLink.searchParams) {
            if (['url', 'u', 'initialMedia', 'content', 'canonicalUrl'].includes(param)) {
              if (targetUrl.hostname.includes('archive.org')) {
                toggleStartParam(targetUrl, valueInSeconds);
                sharerLink.searchParams.set(param, targetUrl.href);
              }
            }
          }
          link.setAttribute('href', sharerLink.href);
        });
      }

      // Update iframe embed code in `#embedcodehere`
      const updateIframeEmbedLink = (value) => {
        const textarea = document.getElementById('embedcodehere');
        if (!textarea) return;

        const doc = new DOMParser().parseFromString(textarea.value, 'text/html');
        const iframe = doc.querySelector('iframe');
        if (!iframe) return;

        const src = new URL(window.location.href);
        src.hostname = 'archive.org';
        src.pathname = src.pathname.replace('/details/', '/embed/');

        toggleStartParam(src, timecodeToSeconds(value));
        iframe.src = src.href;
        textarea.value = iframe.outerHTML;
      }

      // Update WordPress shortcode in `#embedcodehereWP`
      const updateWPEmbedShortCode = (value) => {
        const textareaWP = document.getElementById('embedcodehereWP');
        let shortCode = textareaWP.value.replace(/(\?start=[^&\s]+)/g, '');

        const url = new URL(window.location.href);
        const pathname = url.pathname.split('/details/')[1];

        if (checkbox.checked && timecodeToSeconds(value) > 0) {
          shortCode = shortCode.replace(/(\[archiveorg\s+)([^\s]+)/, `$1${pathname}?start=${timecodeToSeconds(value)}`);
        } else {
          shortCode = shortCode.replace(/(\[archiveorg\s+)([^\s]+)/, `$1${pathname}`);
        }
        textareaWP.value = shortCode;
      }

      const updateEmbedLinks = () => {
        const { value } = inputField;
        if (checkbox.checked && !isValidTimeFormat(value)) {
          return;
        }
        updateIframeEmbedLink(value);
        updateWPEmbedShortCode(value);
      };

      checkbox.addEventListener('change', () => {
        updateShareLinks();
        updateEmbedLinks();
      });

      inputField.addEventListener('input', (e) => {
        const { value } = e.target;
        const newValue = value.replace(/[^0-9:]/g, '');
        if (newValue !== value) {
          e.target.value = newValue;
        }
        if (newValue) {
          checkbox.checked = true;
        }
        updateShareLinks();
        updateEmbedLinks();
      });

      inputField.addEventListener('blur', () => {
        inputField.value = formatTimecode(inputField.value);
        updateShareLinks();
        updateEmbedLinks();
      });

      $('#cher-modal').on('shown.bs.modal', () => {
        updateInputField();
      })

      $('#cher-modal').on('hidden.bs.modal', () => {
        checkbox.checked = false;
        checkbox.dispatchEvent(new Event('change'));
      })
    }
  }

  $('#cher-modal').on('shown.bs.modal', () => {
    const modal = $('#cher-modal');
    const closeButton = modal.find('.close');
    const focusTrapStart = modal.find('.focus-trap-start');
    const focusTrapEnd = modal.find('.focus-trap-end');

    // Move keyboard focus to the modal's close button by default when opened
    closeButton.focus();

    // Set up focus traps for the share modal
    focusTrapStart.on('focus', () => {
      // Wrap around to the last focusable element
      const modalContent = $('#cher-modal .modal-content');
      AJS.focus_last_descendent(modalContent, closeButton);
    })

    focusTrapEnd.on('focus', () => {
      // Send focus to the Close button at the top of the dialog
      closeButton.focus();
    })
  })

  $('#cher-modal').on('hidden.bs.modal', () => {
    // Return keyboard focus to the element that opened the modal
    $('[data-target="#cher-modal"]').focus();
  })
  // End for details.inc
})

window.AJS = AJS  // promote to global (for inline JS in emitted markup from PHP mostly)

export { AJS as default }
